import { useTranslation } from 'react-i18next'
import { PageMeta } from '@/components/ui/PageMeta'
import { HomeHero } from '@/components/home/HomeHero'
import { PhilosophyGrid } from '@/components/home/PhilosophyGrid'
import { KitchenSection } from '@/components/home/KitchenSection'
import { Footer } from '@/components/layout/Footer'

export function Home() {
  const { t, i18n } = useTranslation('home')
  const lang = i18n.language as 'it' | 'en'
  const canonicalPath = `/${lang}`

  const jsonLd = [
    {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      name: 'Maia e Tas',
      url: 'https://maiaetas.it',
      logo: 'https://maiaetas.it/media/logo-maia.jpg',
      sameAs: [
        'https://www.instagram.com/maiaetas_crema/',
        'https://www.instagram.com/baretas_crema/',
      ],
      telephone: '+39-333-702-4046',
    },
    {
      '@context': 'https://schema.org',
      '@type': 'Restaurant',
      name: 'Maia e Tas',
      image: 'https://maiaetas.it/media/logo-maia.jpg',
      address: {
        '@type': 'PostalAddress',
        streetAddress: 'Via Piacenza 97',
        addressLocality: 'Crema',
        addressRegion: 'CR',
        postalCode: '26013',
        addressCountry: 'IT',
      },
      telephone: '+39-333-702-4046',
      servesCuisine: 'Italian',
      priceRange: '€€',
      url: `https://maiaetas.it/${lang}/maia-e-tas`,
    },
    {
      '@context': 'https://schema.org',
      '@type': 'BarOrPub',
      name: 'Bar e Tas',
      image: 'https://maiaetas.it/media/logo-bar.jpg',
      address: {
        '@type': 'PostalAddress',
        streetAddress: 'Via Ponte della Crema 1/2',
        addressLocality: 'Crema',
        addressRegion: 'CR',
        postalCode: '26013',
        addressCountry: 'IT',
      },
      telephone: '+39-333-702-4046',
      url: `https://maiaetas.it/${lang}/bar-e-tas`,
    },
    {
      '@context': 'https://schema.org',
      '@type': 'Restaurant',
      name: 'Pizza e Tas',
      image: 'https://maiaetas.it/media/logo-pizza.jpg',
      address: {
        '@type': 'PostalAddress',
        streetAddress: 'Piazzale Rimembranze',
        addressLocality: 'Crema',
        addressRegion: 'CR',
        postalCode: '26013',
        addressCountry: 'IT',
      },
      telephone: '+39-333-702-4046',
      url: `https://maiaetas.it/${lang}/pizza-e-tas`,
    },
  ]

  return (
    <>
      <PageMeta
        title={t('meta.title')}
        description={t('meta.description')}
        canonicalPath={canonicalPath}
        jsonLd={jsonLd}
      />

      <main id="main-content">
        <HomeHero />

        <PhilosophyGrid />

        <KitchenSection />
      </main>

      <Footer variant="maia" />
    </>
  )
}
